/**
 * @generated SignedSource<<825d779d2fdb6fc48797948afea1c53c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_user" | "PdpSharedIconBubbleEmail_user">;
  readonly " $fragmentType": "PdpRespIconBubbles_user";
};
export type PdpRespIconBubbles_user$key = {
  readonly " $data"?: PdpRespIconBubbles_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbleShare_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "af25b1e1a8218027daf05e2a7fc2320e";

export default node;
